import { Rank } from '../../sim/defs';
import { Fam } from '../../sim/pools/BulletPool';
import { defineEnemy, Motion, Pattern } from '../schema';

/** E-M10 — KYSTE. Le bouclier « bulle », à crever avant le corps.
 *
 *  Le Rempart et l'Égide imposent un ANGLE d'attaque (un cône protégé) : on les
 *  résout en se déplaçant. Le Kyste impose un ORDRE : une BULLE l'enveloppe de
 *  tous côtés, sans angle mort, et le noyau est intouchable tant qu'elle tient.
 *  Aucun placement ne la contourne — il faut la CREVER, puis frapper le noyau
 *  qu'elle révèle. C'est la variante 360° du bouclier, et elle réutilise
 *  exactement le mécanisme des parties destructibles (`shieldedByParts` + une
 *  partie « bulle » à l'offset zéro) : rien de neuf côté moteur.
 *
 *  ── Ce qu'il enseigne ──
 *  Que certaines défenses ne se contournent pas, elles se démontent — et que
 *  l'ordre de destruction est imposé, pas choisi. Là où l'Égide laisse le choix
 *  entre casser le bouclier ou le contourner, le Kyste ne laisse qu'une route :
 *  la bulle d'abord, le noyau ensuite. C'est le pont vers les boss à parties
 *  destructibles, où « quoi viser en premier » devient la question centrale.
 *
 *  ── Pourquoi le noyau tire pendant qu'on crève la bulle ──
 *  Le noyau lâche un anneau lent PENDANT qu'il est protégé : sans cette pression,
 *  crever la bulle serait un simple temps de charge sans risque. L'anneau oblige
 *  à casser la bulle EN esquivant, ce qui donne son sel au combat — le noyau est
 *  invulnérable mais pas inoffensif.
 *
 *  ── Pourquoi une bulle plus grosse que le noyau ──
 *  La bulle (rayon 48) enferme visiblement le noyau (rayon 24) : le joueur voit
 *  ce qu'il frappe et voit la bulle s'user. Un bouclier qu'on ne voit pas n'est
 *  pas une mécanique, c'est un mur (PLAN.md §6.4). */
export default defineEnemy({
  id: 'kyste',
  rank: Rank.Heavy,
  hp: 200,
  visualRadius: 24,
  score: 420,
  telegraph: 1.1,
  drops: 3,
  motion: { kind: Motion.Anchor, speed: 200, holdY: 320 },
  // ⚠️ Le noyau est INTOUCHABLE tant que la bulle vit. C'est le mécanisme
  // existant, à l'identique du Bastion — une partie à l'offset zéro qui enveloppe
  // le corps au lieu de le flanquer.
  shieldedByParts: true,
  parts: [{ enemy: 'bulle', offX: 0, offY: 0 }],
  emitter: {
    // Anneau lent : pression pendant que la bulle tombe. Il tire même protégé —
    // « intouchable » ne veut pas dire « inoffensif ».
    pattern: Pattern.Ring,
    every: 2.0,
    count: 10,
    speed: 320,
    stepDeg: 9,
    firstDelay: 1.6,
    family: Fam.EnemyPurple,
  },
});
